<template>
  <div v-if="loading">
    <Loading />
  </div>
  <div
    v-else-if="$route.query._gu"
    class="relative-position full-height column"
  >
    <UserProfile :userProfile="userProfile" @updated="getUserProfile()" />
    <SampleList :samples="(userProfile || {}).samples || []" />

    <LockMask
      v-if="adminStatusStore[REMOVING_GROUP_MEMBERS]"
      lock-tip="正在操作分组内的用户列表"
    />
  </div>

  <div class="row items-center justify-center " v-else>
    <Empty text="请先选择用户" />
  </div>
</template>

<script>
import { REMOVING_GROUP_MEMBERS } from "@/status/admin.status";
import AdminCommonStatus from "@/views/Admin/mixins/status.mixin";
import { fetchUserProfile } from "@/api/endpoints/user/fetchUserProfile";

export default {
  mixins: [AdminCommonStatus],

  components: {
    LockMask: () => import("@/components/Mask"),
    Empty: () => import("@/components/Empty"),
    Loading: () => import("@/components/Loading"),
    UserProfile: () => import("./UserProfile"),
    SampleList: () => import("./SampleList"),
  },

  data() {
    return {
      userProfile: null,
      loading: false,
      REMOVING_GROUP_MEMBERS,
    };
  },

  watch: {
    "$route.query._gu": {
      immediate: true,
      handler(id) {
        if (!id) return;
        this.getUserProfile(id);
      },
    },
  },
  methods: {
    /**
     * 获取当前用户的信息
     */
    async getUserProfile(userId = this.$route.query._gu) {
      if (!userId) return;
      this.loading = true;
      try {
        this.userProfile = null;
        const res = await fetchUserProfile(userId);
        if (res.status || res.error) {
          this.$q.notfiy({
            type: "danger",
            message: res.detail || res.message,
          });
        } else {
          this.$set(this, "userProfile", res);
          this.$forceUpdate();
        }
      } catch (err) {
        console.log(err);
        this.$q.notfiy({
          type: "message",
          message: "获取用户信息时发生未知错误",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
